import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { OMSSchedulerSettingsRulesFormType } from '@lp/features/Scheduler/SchedulerOMSSettings/types';
import { getNumberInputValue, getNumberInputValueHandler } from '@lp/features/Scheduler/utils';

type OMSSchedulerSettingsRulesFormProps = {
  isReadOnly: boolean;
};

export const OMSSchedulerSettingsRulesForm = ({ isReadOnly }: OMSSchedulerSettingsRulesFormProps) => {
  const { control } = useFormContext<OMSSchedulerSettingsRulesFormType>();

  return (
    <div className="flex flex-col gap-5 w-full p-6 bg-white rounded-2xl shadow-s">
      <span className="text-base-5 text-xl-sb">Individual Workload Requirements</span>

      <div className="flex gap-4 flex-col">
        <span className="text-base-5 text-l-m">Shifts per Month</span>
        <div className="flex gap-5">
          <Controller
            name="minOnCallShiftsSlotsPerPeriod"
            control={control}
            render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
              <Input
                type="number"
                aria-label="minOnCallShiftsSlotsPerPeriod"
                isInvalid={invalid}
                isDisabled={isReadOnly}
                errorMessage={error?.message}
                className="max-w-30"
                label="On Call"
                placeholder="On Call"
                value={getNumberInputValue(value)}
                onValueChange={getNumberInputValueHandler(onChange)}
                {...field}
              />
            )}
          />
          <Controller
            name="minAdminDaySlotsPerPeriod"
            control={control}
            render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
              <Input
                type="number"
                aria-label="minAdminDaySlotsPerPeriod"
                isInvalid={invalid}
                isDisabled={isReadOnly}
                errorMessage={error?.message}
                className="max-w-30"
                label="Admin Days"
                placeholder="Admin Days"
                value={getNumberInputValue(value)}
                onValueChange={getNumberInputValueHandler(onChange)}
                {...field}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};
